import checkItemByCinemasArray from "./checkItemByCinemasArray"
import checkPerformanceByCinemasArray from "./checkPerformanceByCinemasArray"
import checkPerformanceByTimeRange from "./checkPerformanceByTimeRange"

const checkMovieByTimeRangeAndCinemas = (movie, performances, startDate, endDate, cinemaIds = false) => {
    const data = {
        inCinema: false,
        isCurrent: false,
        isFuture: false
    }

    if(!movie) {
        return data
    }

    if(cinemaIds && !checkItemByCinemasArray(movie, cinemaIds, 'cinemaIds')) {
        return data
    }

    if(!movie.hasOwnProperty('performances') || 0 === movie.performances.length) {
        data.inCinema = true
        return  data
    }

    movie.performances.find(perfId => {
        const performance = performances[perfId]

        if(cinemaIds && !checkPerformanceByCinemasArray(cinemaIds, performance) || (movie.id !== performance.cliMoviePk)) {
            return false
        } else {
            if(!data.inCinema)  {
                data.inCinema = true
            }

            if(checkPerformanceByTimeRange(startDate, endDate, performance)) {
                data.isCurrent = true

                return true
            } else {
                if(!data.isFuture) {
                    data.isFuture = true
                }
                
                return false
            }
        }
    })


    return data
}

export default checkMovieByTimeRangeAndCinemas